// Gate for development/verification UI.
//
// Presentation only. Nothing behind this flag is a capability: the pricing
// engine, the backend requests, and every number they return are identical
// whether it is on or off. It decides who SEES the internal verification
// controls (the row-4 fixture check, the engine status line, the
// live/est. legend), which have no place in a normal user's quote screen but
// are still the fastest way to prove the engine answered during development.
//
// Two ways to turn it on, both read at render time:
//   - ?dev=1 on any app URL — no rebuild, survives client-side navigation
//     because react-router preserves the query string.
//   - REACT_APP_DEV_TOOLS=1 in frontend/.env — for a whole dev session.
//
// The REACT_APP_ prefix is required: this app is CRA behind CRACO, not Vite,
// so any other prefix is silently dropped from process.env at build time.

export function devToolsEnabled(): boolean {
  if (process.env.REACT_APP_DEV_TOOLS === "1") return true;
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get("dev") === "1";
}
